import { Stack } from "@mui/material";
import CogsTable from "./table";

const RecipeCost = () => {
  return (
    <Stack spacing={3}>
      <CogsTable />
    </Stack>
  );
};

export default RecipeCost;
